// Tiny helper for posting gamification interaction events. Best-effort,
// silenced on failure, debounced per (event_type, key) to avoid spam.
import api from './api';

const lastSent = new Map();
const DEBOUNCE_MS = 30_000;

export function trackGameEvent(type, metadata) {
  const key = `${type}:${metadata?.key || ''}`;
  const now = Date.now();
  const prev = lastSent.get(key);
  if (prev && now - prev < DEBOUNCE_MS) return;
  lastSent.set(key, now);
  api.post('/gamification/event', { type, metadata: metadata || {} }).catch(() => {});
}
